import { Component, Input, OnChanges, inject } from '@angular/core';
import { Status } from 'src/app/models/Status';
import { DateTimeUtilService } from 'src/app/services/date-time-util.service';
import { NgClass, DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  imports: [NgClass, DatePipe, TranslatePipe],
})
export class TitleComponent implements OnChanges {
  private readonly dateTimeUtil = inject(DateTimeUtilService);

  @Input() questionnaire;
  expiry = {
    date: '',
    display: '',
  };
  formExpired;

  ngOnChanges() {
    const endDate = this.questionnaire?.effectivePeriod?.end;
    if (endDate) {
      const currDate = new Date();
      this.formExpired = this.dateTimeUtil.onOrBefore(currDate, endDate)
        ? Status.NOT_EXPIRED
        : Status.EXPIRED;
      this.expiry = {
        display: this.dateTimeUtil.getDisplayFormat(endDate),
        date: endDate,
      };
    }
  }
}
